import { FC, memo, useRef, } from 'react';
import { Box, Fab, Grow } from '@mui/material';
import Draggable from 'react-draggable';
import CasaAI from '../../../../shared/icons/CasaAI';
import styles from './MinimizedChatIcon.module.scss';
import useDraggableChat from "../../hooks/useDraggableChat";

interface MinimizedChatIconProps {
  onClick: () => void;
  onClose: () => void;
}

const MinimizedChatIcon: FC<MinimizedChatIconProps> = ({ onClick, onClose }) => {
    const {dragPosition, setDragPosition,} = useDraggableChat();
    const nodeRef = useRef(null);

    const startPos = useRef({ x: 0, y: 0 });

    const handleStart = (e: any, data: any) => {
        startPos.current = { x: data.x, y: data.y };
    };

    const handleStop = (e: any, data: any) => {
        setDragPosition({ x: data.x, y: data.y });

        const deltaX = Math.abs(data.x - startPos.current.x);
        const deltaY = Math.abs(data.y - startPos.current.y);

        if (deltaX < 5 && deltaY < 5) {
            onClick();
        }
    };

    return (
        <Draggable nodeRef={nodeRef}
                   position={dragPosition}
                   onStart={handleStart}
                   onStop={handleStop}
                   bounds="body"
        >
            <Box ref={nodeRef}  className={styles.minimizedContainer} sx={{ bottom: 24, right: 24, cursor: 'grab' }}>
                <Grow in={true}>
                    <Fab aria-label="open chat"
                         component="div"
                         sx={{
                            width: 72,
                            height: 72,
                            backgroundColor: '#040404ff',
                            '&:hover': {
                                backgroundColor: '#222'
                            },
                            '& svg': {
                                fontSize: 100
                            }
                        }}
                    >
                        <CasaAI/>
                    </Fab>
                </Grow>
            </Box>
        </Draggable>
    );
};

export default memo(MinimizedChatIcon);